// extracted by css-extract-rspack-plugin
export default {"cls1":"StatCells-cls1_kyl","cls2":"StatCells-cls2_p7K StatCells-cls1_kyl"};